/**
 * `/` — the app's home: Pulpit, the trainer's dashboard.
 *
 * The session's routing table sends every live session here (`routeForSessionStatus` in
 * `entities/session`), so this is the first screen a signed-in trainer sees.
 *
 * It was the client roster until 23 September 2026, when the owner moved the landing page to the
 * dashboard. The roster moved to `/klienci`, beside the client detail and the archive it already
 * led to, and `/pulpit`, the dashboard's address since 15 September, redirects here so a bookmark
 * of it still lands.
 */

import { createFileRoute } from '@tanstack/react-router';

import { SessionOverlay } from '~/pages/assigned-plan-calendar';
import { TrainerHomeScreen } from '~/pages/trainer-home';

export const Route = createFileRoute('/_shell/')({
  component: PulpitRoute,
});

/**
 * The one session panel, laid over this screen by „Zobacz sesję" (owner, 25 September 2026) — the
 * panel the client detail lays over Przegląd, composed here because a page may not import a page.
 * It opens to READ, and offers no „Pokaż w planie": that walk is resolved per client on the client
 * detail, which this screen is not.
 */
function PulpitRoute() {
  return (
    <TrainerHomeScreen
      renderSessionPanel={(workoutExecutionId, onClose) => (
        <SessionOverlay
          key={workoutExecutionId}
          workoutExecutionId={workoutExecutionId}
          focusComment={false}
          onClose={onClose}
          onShowInPlan={null}
        />
      )}
    />
  );
}
